import { Site } from '@envato/foundation-types'

const experimentConfig = {
  homePageTrafficToElementsPhase1: {
    experimentId: 'XG-yGCFBT7GfsMNCiSaLRA',
    running: true,
    loadingCover: true,
    sites: [
      Site.audiojungle,
      Site.codecanyon,
      Site.graphicriver,
      Site.photodune,
      Site.themeforest,
      Site.videohive
    ],
    variants: {
      0: {
        homePageElementsBanner: false,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: false
      },
      1: {
        homePageElementsBanner: false,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: false
      },
      2: {
        homePageElementsBanner: true,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: false
      },
      3: {
        homePageElementsBanner: true,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: false
      },
      4: {
        homePageElementsBanner: true,
        homePageElementsBannerAltCTA: true,
        homePageEnvatoProductsBanner: false
      },
      5: {
        homePageElementsBanner: true,
        homePageElementsBannerAltCTA: true,
        homePageEnvatoProductsBanner: false
      },
      6: {
        homePageElementsBanner: false,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: true
      },
      7: {
        homePageElementsBanner: false,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: true
      }
    }
  },
  categoryPageCuratedItemsBlockGR: {
    experimentId: 'goEF7M94S12cAEcozNNhdg',
    running: true,
    loadingCover: true,
    sites: [Site.graphicriver],
    variants: {
      0: {
        categoryPageBlocksB: false
      },
      1: {
        categoryPageBlocksB: false
      },
      2: {
        categoryPageBlocksB: true
      },
      3: {
        categoryPageBlocksB: true
      }
    }
  }
}

export default experimentConfig
